<rt-box variant="no-padding">
  <div layout layout-vertical layout-full-width padding-lr-medium>
    @for (group of usersGroupedByAccessKind(); track group.id) {
      <div>
        <rt-users-grouped-by-access-kind-list-item [group]="group" [isLast]="$last" />
      </div>
    }
  </div>
</rt-box>
